// extracted by mini-css-extract-plugin
export var testimonialBox = "testimonialVideo-module--testimonialBox--2wAm6";
export var testimonialVideoTitle = "testimonialVideo-module--testimonialVideoTitle--3LZSQ";
export var testimonialVideoWatchText = "testimonialVideo-module--testimonialVideoWatchText--zgZYu";